import React from "react"
import defaultIcon from "../../assets/images/lexikon/lexikon_item_default.svg"
import errorIcon from "../../assets/images/lexikon/lexikon-error.svg"
import { Link } from "gatsby"

const LexikonBadge = ({item}) => {

  const {node: myItem} = item;

  if (myItem) {
    return (
      <div className="col-lg-6 col-xs-12">
        <Link to={`${myItem.fields.slug}`} style={{textDecoration: "none"}}>
          <div className="lexikon-badge-box">
            <div className="icon">
              {<img src={defaultIcon} alt={"default Lexikon Item"} />}
            </div>
            {myItem.frontmatter.question}
          </div>
        </Link>
      </div>
    )
  } else {
    return (
      <div className="col-lg-6 col-xs-12" key={1}>
        <div className="lexikon-badge-box">
          <div className="icon">
            <img src={errorIcon} alt={"default Lexikon Error Item"} />
          </div>
        </div>
      </div>
    )
  }


}

export default LexikonBadge
